import { ReportRunSchedule, UpdateReportRunScheduleInput } from '@/API';
import { GenericRepository } from '@/repository/GenericRepository.ts';
import * as mutations from '@/graphql/mutations.ts';
import * as queries from '@/graphql/queries.ts';
import { GraphQLOptionsV6 } from '@aws-amplify/api-graphql';

export class ReportScheduleRepository extends GenericRepository<ReportRunSchedule> {
  constructor() {
    super();
  }

  public async save(
    reportRunSchedule:
      | ReportRunSchedule
      | Omit<
          ReportRunSchedule,
          '__typename' | 'id' | 'createdAt' | 'updatedAt' | 'owner'
        >
  ): Promise<ReportRunSchedule> {
    return (
      await this.client.graphql({
        query: mutations.createReportRunSchedule,
        variables: {
          input: reportRunSchedule,
        },
      })
    ).data.createReportRunSchedule as ReportRunSchedule;
  }

  public async update(
    reportRunSchedule: UpdateReportRunScheduleInput
  ): Promise<ReportRunSchedule> {
    return (
      await this.client.graphql({
        query: mutations.updateReportRunSchedule,
        variables: {
          input: reportRunSchedule,
        },
      })
    ).data.updateReportRunSchedule as ReportRunSchedule;
  }

  // New method to update the subscription status for a report.
  public async updateSubscription({
    reportId,
    subscribe,
  }: {
    reportId: string;
    subscribe: boolean;
  }): Promise<ReportRunSchedule> {
    return (
      await this.client.graphql({
        query: mutations.updateReportSubscription,
        variables: {
          reportId,
          subscribe,
        },
      })
    ).data.updateReportSubscription as ReportRunSchedule;
  }

  public async get(id: string) {
    const reportSchedule = (
      await this.client.graphql({
        query: queries.getReportRunSchedule,
        variables: { id },
      })
    ).data.getReportRunSchedule;
    if (!reportSchedule) {
      throw new Error('ReportSchedule not found');
    }
    return reportSchedule as ReportRunSchedule;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public async list(options?: GraphQLOptionsV6['variables']) {
    return (
      await this.client.graphql({
        query: queries.listReportRunSchedules,
      })
    ).data.listReportRunSchedules;
  }
}
